import Lenis from "lenis";
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";

// GA4 - DataLayer
window.dataLayer = window.dataLayer || [];

// Lenis scrolling
(function () {
    const norm = s => (s.endsWith('/') ? s : s + '/');

    document.addEventListener('click', (e) => {
        const a = e.target.closest('a[href]');
        if (!a) return;

        // Skip links inside excluded containers
        if (a.closest('#menuModal') || a.closest('.nav')) return;

        const raw = a.getAttribute('href');

        // Case 1: pure hash "#tiers"
        if (raw && raw.startsWith('#')) {
            e.preventDefault();
            const id = raw.slice(1);
            const el = document.getElementById(id);
            if (!el) return;

            const offset = -100;
            if (window.lenis && typeof window.lenis.scrollTo === 'function') {
                window.lenis.scrollTo(el, {offset});
            } else {
                const y = el.getBoundingClientRect().top + window.scrollY + offset;
                window.scrollTo({top: y, behavior: 'smooth'});
            }
            history.replaceState(null, '', raw);
            return;
        }

        // Case 2: absolute/relative URL with hash (e.g. "/page#tiers")
        try {
            const url = new URL(raw, window.location.origin);
            const same_page = (url.origin === location.origin) && (norm(url.pathname) === norm(location.pathname)) && url.hash;
            if (!same_page) return;

            e.preventDefault();
            const id = url.hash.slice(1);
            const el = document.getElementById(id);
            if (!el) return;

            const offset = -100;
            if (window.lenis && typeof window.lenis.scrollTo === 'function') {
                window.lenis.scrollTo(el, {offset});
            } else {
                const y = el.getBoundingClientRect().top + window.scrollY + offset;
                window.scrollTo({top: y, behavior: 'smooth'});
            }
            history.replaceState(null, '', url.hash);
        } catch {
            // invalid URL — ignore
        }
    }, {passive: false});
})();

document.addEventListener('DOMContentLoaded', () => {
    const videos = document.querySelectorAll('.lazy-video');

    const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
            if (!entry.isIntersecting) return;

            console.log(entry)

            const video = entry.target;
            const src = video.dataset.src;

            if (src) {
                video.src = src;
                video.load();
            }

            obs.unobserve(video);
        });
    }, {
        rootMargin: '200px'
    });

    videos.forEach(video => observer.observe(video));
});

// Alpine (Show when rendered to avoid flashing)
window.addEventListener("alpine:init", () => {
    const loading_element = document.querySelector(".alpine-loading");
    const alpine_elements = document.querySelectorAll(".alpine");

    if (loading_element) {
        loading_element.remove();
    }

    alpine_elements.forEach(element => {
        element.classList.remove("alpine-hidden");
        element.classList.add("alpine-ready");
    });
});

// Loading Show/Hide Helper
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.btn-confirm').forEach(button => {
        button.addEventListener('click', () => {
            if (window.Loading && typeof Loading.show === 'function') {
                Loading.show();
            } else {
                console.warn('Loading.show() is not available.');
            }
        });
    });

    document.querySelectorAll('.btn-confirm.in-modal').forEach(button => {
        button.addEventListener('click', () => {
            if (window.Loading && typeof Loading.show === 'function') {
                Loading.show();
            } else {
                console.warn('Loading.show() is not available.');
            }
        });
    });
});

// Lenis
document.addEventListener("alpine:init", () => {
    const app = document.body?.dataset?.app;

    if (app !== 'public') return;

    const aos_elements = document.querySelectorAll('[data-aos]');
    const has_aos = aos_elements.length > 0;

    if (has_aos) {
        gsap.registerPlugin(ScrollTrigger);
    }

    const lenis = new Lenis({
        duration: 0.9,
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
        smooth: true,
        smoothTouch: false,
    });

    if (has_aos) { lenis.on("scroll", () => ScrollTrigger.update()); }

    function raf(time) {
        lenis.raf(time);
        requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    if (!has_aos) return;

    const AOS_MAP = {
        'fade-in': {opacity: 0},
        'fade-left': {opacity: 0, x: 40},
        'fade-right': {opacity: 0, x: -40}
    };

    aos_elements.forEach(el => {
        const type = el.dataset.aos;
        const delay = (parseInt(el.dataset.aosDelay, 10) || 200) / 1000;
        const duration = (parseInt(el.dataset.aosDuration, 10) || 800) / 1000;

        const from_vars = AOS_MAP[type];
        if (!from_vars) return;

        gsap.from(el, {
            ...from_vars,
            duration,
            delay,
            ease: 'power3.out',
            scrollTrigger: {
                trigger: el,
                start: 'top 85%',
                once: true,
            }
        });
    });

    gsap.set(aos_elements, {willChange: 'transform, opacity'});
});

// AOS
window.addEventListener('alpine:init', function () {
    if (typeof AOS !== 'undefined') {
        AOS.init();
    }
});